import React from "react";
import { motion } from "framer-motion";
import useTitle from "../../hooks/useTitle";

const ArticlesPage = () => {
	useTitle("Articles");

	return (
		<div>
			<h1>Articles Page</h1>
		</div>
	);
};

export default ArticlesPage;
